export default __webpack_public_path__ + "static/image-14-38e0d6dcd43fe399dacf8beeee154ab6.jpg";